import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { resolveLandingRoute } from '@/lib/landingRoute';
import sabotagelogo from '@/assets/sabotage-logo.png';

// SAB-587: authed landing gate mounted at /home behind ProtectedRoute, so `user`
// is present by the time this renders. Runs the landing fallback chain once, then
// redirects. Every authed-landing surface points here (via DEFAULT_AUTHED_HOME)
// so the sport decision lives in exactly one place.
export default function LandingRouter() {
  const { user, isLoading } = useAuth();
  const [dest, setDest] = useState<string | null>(null);

  useEffect(() => {
    if (isLoading) return;
    if (!user) {
      setDest('/auth');
      return;
    }
    let active = true;
    resolveLandingRoute(user.id).then((d) => {
      if (active) setDest(d);
    });
    return () => {
      active = false;
    };
  }, [user, isLoading]);

  if (!dest) {
    // Match ProtectedRoute's loading visual so there is no flash between the two.
    return (
      <div className="min-h-screen bg-background flex flex-col items-center justify-center">
        <img src={sabotagelogo} alt="Sabotage Fantasy" className="h-14 w-auto animate-pulse" />
      </div>
    );
  }
  return <Navigate to={dest} replace />;
}
